export const ChartPalette = [
  '#338EED', // blue
  '#EE477E', // red
  '#339D82', // green
  '#D07552', // orange
  '#FFD166', // yellow
  '#1FB7EA', // skyblue
] as const;
